import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';

interface routeParams {
  siteType?: string;
  site?: string;
  area?: string;
}

@Injectable({ providedIn: 'root' })
export class RouteHelperService {

  constructor(
    private router: Router
  ) {}

  getActiveRouteParams(stateRoot = this.router.routerState.snapshot.root) {
    // This is the recommended way to get active route info outside of a component :(
    // https://angular.dev/api/router/ActivatedRouteSnapshot#params
    let params: routeParams = {};
    let stack: ActivatedRouteSnapshot[] = [stateRoot];
    while (stack.length > 0) {
      const route = stack.pop()!;
      params = {...params, ...route.params};
      stack.push(...route.children);
    }
    return params;
  }

}
